




import { Vue, Component } from "vue-property-decorator";
import { MsgTransports } from "@/store/types";
import GroupIncoming from "@/pages/Pages/Statistics/GroupIncoming.vue";

@Component({ components: { GroupIncoming } })
export default class ViberDetailIncoming extends Vue {
  private transport: MsgTransports = MsgTransports.WHATSAPP;
}
